import { useEffect, useState } from "react";

/**
 * Returns a debounced copy of `value` that only updates after `ms` of silence.
 */
export function useDebounce<T>(value: T, ms: number): T {
    const [debounced, setDebounced] = useState<T>(value);

    useEffect(() => {
        const t = setTimeout(() => setDebounced(value), ms);
        return () => clearTimeout(t);
    }, [value, ms]);

    return debounced;
}

export default useDebounce;
